import React from "react";

const CustomersIcon = ({ stroke, ...props }) => {
  stroke = stroke || "url(#paint3_linear_11152_30178)";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.875 15C10.5674 15 12.75 12.8174 12.75 10.125C12.75 7.43261 10.5674 5.25 7.875 5.25C5.18261 5.25 3 7.43261 3 10.125C3 12.8174 5.18261 15 7.875 15Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.21875 18.3759C1.98486 17.3297 2.9868 16.4788 4.1433 15.8922C5.29979 15.3057 6.57827 15 7.875 15C9.17173 15 10.4502 15.3057 11.6067 15.8922C12.7632 16.4788 13.7651 17.3297 14.5312 18.3759"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.125 15C17.4218 14.9989 18.7006 15.3039 19.8573 15.8904C21.0139 16.4769 22.0158 17.3282 22.7812 18.375"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8706 5.41312C15.5407 5.23528 16.241 5.20241 16.9248 5.3167C17.6086 5.43099 18.2601 5.68981 18.836 6.07589C19.4118 6.46197 19.8987 6.96643 20.2641 7.5556C20.6295 8.14478 20.865 8.80511 20.9549 9.49253C21.0449 10.18 20.9872 10.8787 20.7857 11.542C20.5841 12.2054 20.2435 12.8181 19.7863 13.3393C19.3292 13.8606 18.7662 14.2783 18.1348 14.5647C17.5035 14.851 16.8183 14.9995 16.125 15"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11152_30178"
          x1="3.2458"
          y1="10.125"
          x2="12.7086"
          y2="10.0592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11152_30178"
          x1="1.55436"
          y1="16.688"
          x2="14.4656"
          y2="16.3339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11152_30178"
          x1="16.2928"
          y1="16.6875"
          x2="22.7521"
          y2="16.5989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11152_30178"
          x1="15.025"
          y1="10.125"
          x2="20.9703"
          y2="10.099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default CustomersIcon;
